import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TextComponent } from '@cf/shared/ui/typography';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-booking-steps',
  templateUrl: './booking-steps.component.html',
  styleUrls: ['./booking-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextComponent, NgxTolgeeModule],
})
export class BookingStepsComponent {
  @Input() stepIndex = 0;

  @Output() emitStep: EventEmitter<number> = new EventEmitter();
}
